<div class="veify-email-success-container">
  <img src="assets/generalImage/email_verify_sucess.svg" alt="mascot" />

  <p class="desc">{{'desc.email.verification.success' | translate}}</p>

  <app-button [textButton]="true" [buttonName]="'label.back.to.home'" (click)="navigateToHome()"></app-button>
</div>
